<div class="row row-sm">
    <div class="col-lg-12">

        <div class="card-body">
            <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Course Schedule
                        </b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        Add New Course Schedule Information
                    </p>
                </div>
            </div>
            <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Course Schedule
                        </b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        Update Selected Course Schedule Information
                    </p>
                </div>
            </div>
            <div class="bc d-flex align-items-center pl-3" *ngIf="deleteButton">
                <img alt="Logo" src="../../assets/img/FacultyMaster.png" class="mh-40px pb-2">
                <div class="ml-2">
                    <h3 class="main-content-label mb-1"><b>
                            Course Schedule
                        </b></h3>
                    <p class="text-muted card-sub-title mb-0">
                        Delete Selected Course Schedule Information
                    </p>
                </div>
            </div>
            <div class="row">

                <hr class="mt-3">

                <div class="row row-sm add-form">
                    <form autocomplete="off" class="p-0" novalidate [formGroup]="CourseSchForm">
                        <div class="col-lg-12 col-md-12">

                            <!-- <div class="card custom-card"> -->
                            <div class="card-body">

                                <div class="row clearfix">
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.course-schedule.titleList.CoSchOpen' |
                                                        translate}}
                                                    </mat-label>

                                                    <mat-select required #select566 formControlName="CShCoCode"
                                                        [disabled]="isread" [disabled]="isreaddelete">
                                                        <mat-select-filter *ngIf="select566.focused"
                                                            [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                            [array]="courseList"
                                                            (filteredReturn)="filteredListCourse =$event">
                                                        </mat-select-filter>
                                                        <mat-option *ngFor="let item of filteredListCourse"
                                                            [value]="item.CoCode" (click)="getExam(item.CoName)">
                                                            {{item.CoCode}} - {{item.CoName}}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error class="margin_tp"
                                                        *ngIf="CourseSchForm.controls['CShCoCode'].touched && CourseSchForm.controls['CShCoCode'].errors?.required">
                                                       Mandatory
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.course-schedule.titleList.CoSchCoName' |
                                                        translate}}
                                                    </mat-label>
                                                    <input readonly maxlength="60"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        type="text" placeholder="Exam Name" formControlName="CoName"
                                                        matInput>

                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width">
                                                    <mat-label>
                                                        {{'header.course-schedule.titleList.CoSchStatus'
                                                        | translate}}
                                                    </mat-label>
                                                    <mat-select formControlName="CShStatus"
                                                        [disabled]="isread" [disabled]="isreaddelete">
                                                        <mat-option value="O">Open</mat-option>
                                                        <mat-option value="C">Close</mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-sm-4">
                                        <div class="form-group">
                                            <div class="">
                                                <mat-form-field appearance="outline" class="example-full-width ">
                                                    <mat-label>
                                                        {{'header.course-schedule.titleList.CoSchImagePath' |
                                                        translate}}
                                                    </mat-label>
                                                    <input [readonly]="isread" [readonly]="isreaddelete"
                                                        onkeydown="return (event.keyCode!=13);" style="color:black;"
                                                        placeholder="Image Path:" type="text" formControlName="CShPath"
                                                        matInput>
                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div> -->

                                    <!-- <div class="col-sm-3 example-full-width ">
                                        <button [disabled]="isreaddelete" class="file-upload-button example-full-width 
                                        btn sz me-2 mt-0  btn-icon-text btn-raised g-bg-blush2"><input type="file"
                                                #fileInput (change)="onFileSelect(fileInput)" />

                                            Select Path
                                        </button>
                                    </div> -->

                                    <div class="row col-sm-12">
                                        <div class="col-sm-12 prpl">
                                            <button type="button" *ngIf="deleteButton && CourseScDelete"
                                                class="btn wd btn-primary btn-icon-text floatright mt-1 fr"
                                                (click)="DeletetheRecord()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/trash.gif"
                                                        style="margin-right: 5px;">
                                                    Delete
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="editButton" (click)="print()"
                                                class="btn btn-primary btn-icon-text floatright mt-1 mr-3">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/printer.gif"
                                                        style="margin-right: 7px;">
                                                   Print
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="editButton && CourseScUpdate"
                                                class="btn sz btn-primary btn-icon-text floatright mt-1 fr"
                                                (click)="update()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/edit1.gif"
                                                        style="margin-right: 5px;">
                                                    Update
                                                </span>
                                            </button>
                                            <button type="button" *ngIf="submitButton && CourseScCreate"
                                                class="btn wd btn-primary btn-icon-text floatright mt-1 fr"
                                                (click)="submit()">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/save.gif"
                                                        style="margin-right: 5px;">
                                                    Save
                                                </span>
                                            </button>
                                            <button type="button" [mat-dialog-close]="true"
                                                class="btn wd ml btn-primary btn-icon-text floatright mt-1">
                                                <span style="display: contents; align-items: center;">
                                                    <img width="20vh" src="../../assets/img/turn-left.gif"
                                                        style="margin-right: 7px;">
                                                    Back
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </div>

    </div>
</div>